import { React } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavDropdown, Dropdown, Image } from 'react-bootstrap';
import { useUserContext } from 'contexts/UserContext';
import * as api from 'services/api';
import { useTranslation } from 'react-i18next';

export function Menu() {
    const { t } = useTranslation();
  const navigate = useNavigate();
    const { userData } = useUserContext();

  const handleMoveHome = () => {
    navigate('/home');
  }

  const handleEditProfile = () => {
    if (userData) {
      navigate('/userProfile');
    }
  };

  const handleManageUsers = () => {
    if (userData && (userData.role === 'Admin' || userData.role ==='UserManager')) {
      navigate('/userManagement');
    }
  }

  const handleManageAudits = () => {
    if (userData && userData.role === 'Admin') {
      navigate('/auditManagement');
    }
  }

  const handleControlCentresConfig = () => {
    if (userData && userData.role === 'Admin') {
      navigate('/controlCentresPanel');
    }
    }

    const handleInterventionTypeConfig = () => {
        if (userData && userData.role === 'Admin') {
            navigate('/interventionTypeManagement');
        }
    }

    const handleInterventionConfig = () => {
        if (userData && userData.role === 'Admin') {
            navigate('/interventionManagement');
        }
    }

  const handleAbout = () => {
     navigate('/about');
  }

  const handleLogout = async (event) => {
    event.preventDefault();

    await api.logout();

    localStorage.removeItem('token');
    navigate('/login');
  };

    return (
    <NavDropdown
        id="nav-dropdown-dark-example"
        title={<Image src="./icons/menu.svg"/>}
        menuVariant="dark"
        align="end"
    >
        <div style={{ minWidth: '150px' }}>
            <NavDropdown.Item onClick={handleMoveHome}>{t('menuDeviceManagement')}</NavDropdown.Item>
            
            {userData && (userData.role === 'Admin' || userData.role === 'UserManager') && (
                <>
                    <NavDropdown.Divider />
                    <Dropdown.ItemText style={{ fontSize: '10px', fontWeight: 'bold' }}>{t('menuGestor')}</Dropdown.ItemText>
                    <NavDropdown.Item onClick={handleManageUsers}>{t('menuUserManagement')}</NavDropdown.Item>
                    <NavDropdown.Item onClick={handleInterventionConfig}>{t('int.Menu')}</NavDropdown.Item>

                    {userData && userData.role === 'Admin' && (
                        <>
                            <NavDropdown.Divider />
                            <Dropdown.ItemText style={{ fontSize: '10px', fontWeight: 'bold' }}>{t('menuAdministrator')}</Dropdown.ItemText>
                            <NavDropdown.Item onClick={handleControlCentresConfig}>{t('menuControlCentres')}</NavDropdown.Item>
                            <NavDropdown.Item onClick={handleInterventionTypeConfig}>{t('it.Menu')}</NavDropdown.Item>
                            <NavDropdown.Item onClick={handleManageAudits}>{t('menuAudit')}</NavDropdown.Item>
                        </>
                    )}
                </>
            )}

            <NavDropdown.Divider />
            <NavDropdown.Item onClick={handleEditProfile}>{t('menuMyAccount')}</NavDropdown.Item>
            <NavDropdown.Item onClick={handleAbout}>{t('menuAbout')}</NavDropdown.Item>
            <NavDropdown.Item onClick={handleLogout}>{t('menuLogout')}</NavDropdown.Item>
        </div>
    </NavDropdown>
    );
}